import type { TTextType, TAllColorKeys } from '../HBText/HBText';
import { vars } from '../../theme';
import type { SpacingKey, ColorToken } from '../../styles/layout/layout.types';
import { HBListItemSize } from './HBListItem.types';

export const CONTAINER_PADDING_X: SpacingKey = '6';
export const CONTAINER_PADDING_Y = 1;
export const INNER_CONTAINER_PADDING_X: SpacingKey = '12';

// Background token for the selected state, passed as HBBox's `backgroundColor` prop.
// Same token across all non-disabled themes — disabled shows no selected background.
export const SELECTED_BG_COLOR: ColorToken = 'surface.itemSelected';

export const SIZE_TO_HEIGHT: Record<
    HBListItemSize,
    { defaultSize: number; enlargedSize: number }
> = {
    sm: {
        defaultSize: 38,
        enlargedSize: 54
    },
    md: {
        defaultSize: 42,
        enlargedSize: 64
    }
};

export const SIZE_TO_PADDING: Record<HBListItemSize, SpacingKey> = {
    sm: '4',
    md: '6'
};

export const THEME: Record<
    'neutral' | 'accent' | 'danger' | 'disabled',
    {
        textColor: TAllColorKeys;
        cssColor: string;
        hoverColor: string;
        selectedHoverColor: string;
        textTypes: Record<HBListItemSize, TTextType>;
    }
> = {
    neutral: {
        textColor: 'text.primary',
        cssColor: vars.colors.text.primary,
        hoverColor: vars.colors.surface.itemHover,
        selectedHoverColor: vars.colors.surface.itemSelectedHover,
        textTypes: {
            sm: 'body14',
            md: 'body16'
        }
    },
    accent: {
        textColor: 'text.accent',
        cssColor: vars.colors.text.accent,
        hoverColor: vars.colors.surface.accentHover,
        selectedHoverColor: vars.colors.surface.itemSelectedHover,
        textTypes: {
            sm: 'emphasis14',
            md: 'emphasis16'
        }
    },
    danger: {
        textColor: 'text.danger',
        cssColor: vars.colors.text.danger,
        hoverColor: vars.colors.surface.dangerHover,
        selectedHoverColor: vars.colors.surface.itemSelectedHover,
        textTypes: {
            sm: 'body14',
            md: 'body16'
        }
    },
    disabled: {
        textColor: 'text.disabled',
        cssColor: vars.colors.text.disabled,
        hoverColor: 'transparent',
        selectedHoverColor: 'transparent',
        textTypes: {
            sm: 'body14',
            md: 'body16'
        }
    }
};
